var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Stack from "syf-component-library/ui/spacing/Stack";
import EmailSection from "./EmailSection";
import HeaderSection from "./HeaderSection";
import IncomeSection from "./IncomeSection";
import MultiAccountSection from "./MultiAccountSection";
import { useEditProfileContext } from "../../../context/editProfileContext";
import CustomerName from "../../atoms/CustomerName";
import AddressInputs from "../../molecules/AddressInputs";
import PhoneInputs from "../../molecules/PhoneInputs";
import ProfileRow from "../../molecules/ProfileRow";
import { RowInput } from "../../subcomponents";
import ProfileSection from "../ShowProfile/ShowProfileContent";
var EditProfileContent = function () {
    var _a, _b;
    var t = useTranslation().t;
    var _c = useEditProfileContext(), selectedAccountOption = _c.selectedAccountOption, data = _c.data, alertsError = _c.alertsError, handleAddressSelectChange = _c.handleAddressSelectChange;
    var trigger = useFormContext().trigger;
    useEffect(function () {
        trigger();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsxs(ProfileSection, { children: [selectedAccountOption && _jsx(HeaderSection, {}), _jsx(ProfileRow, __assign({ title: t("labels.name") }, { children: _jsx(CustomerName, { firstName: ((_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a["cipher.firstName"]) || "", lastName: ((_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b["cipher.lastName"]) || "" }) })), _jsx(Stack, { size: "small" }), _jsx(ProfileRow, __assign({ title: t("labels.phone"), flip: "horizontal" }, { children: _jsxs(RowInput, __assign({ "data-private": true }, { children: [_jsx(Stack, { size: "medium" }), _jsx(PhoneInputs, { alertsError: alertsError })] })) })), _jsx(ProfileRow, __assign({ title: t("labels.address") }, { children: _jsx(AddressInputs, { "data-private": true, onChangeSelect: handleAddressSelectChange }) })), _jsx(EmailSection, {}), _jsx(IncomeSection, {}), _jsx(MultiAccountSection, {})] }));
};
export default EditProfileContent;
